import { render, staticRenderFns } from "./Extensions.vue?vue&type=template&id=f2a3bf94&scoped=true"
import script from "./Extensions.vue?vue&type=script&lang=js"
export * from "./Extensions.vue?vue&type=script&lang=js"
import style0 from "./Extensions.vue?vue&type=style&index=0&id=f2a3bf94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a3bf94",
  null
  
)

export default component.exports